import $ from "jquery";
import router from '@/router' // 引入router
import Vue from 'vue';
import utils from '@/js/until.js';

import {setToken,scrollTop} from '@/libs/util'
import until from "./until";


const getLoading = utils.globleLoading();

export const ajax = function (method, url, param, config = {}) {
  // console.log(config)
  return new Promise(function (resolve, reject) {
      // const selfGlobal = getVuePro.call(Vue.prototype).$selfGlobal;
      const selfGlobal = Vue.prototype.$selfGlobal;
      const $localStore = Vue.prototype.$localStore;
      if (config && config.method) {
        selfGlobal && selfGlobal.$globalRequestMeth.methodList.push(config.method);
      }
      if (param && !param.noLoading) {
        getLoading.show();
      }

      $.ajax({
        method: method,
        url: url,
        data: param,
        headers: config && config.headers,
        dataType: 'json',
        crossDomain: true,
        timeout: 60 * 1000, // 响应超时时间1min
        xhrFields: {
          withCredentials: true,
        },
        ...(config.configParams || {}),
        // beforeSend: function (XMLHttpRequest) {
        //   XMLHttpRequest.setRequestHeader("test-token", 'abcd');
        //   XMLHttpRequest.setRequestHeader("test-sessid", 'abcd');
        // },
        success: function (data) {
          // 测试
          // if (test <= 2) {
          //   data.status = 405;
          // }
          // test += 1;

          // 测试结束
          const $globalRequestMeth = selfGlobal && selfGlobal.$globalRequestMeth;
          switch (Number(data.data.login_status) || data.status) {
            case 400:
              console.log(config)
              if (config && config.method && config.method.customeHandleData){
                // 如果要自定义处理返回的错误信息
                console.log('rrrrrrrr')
                resolve(data)
                break;
              }
              // getVuePro.call(Vue.prototype).$Message.error(data.msg);
              Vue.prototype.$Message.error(data.msg);
              reject({
                code: 400,
              })
              // alert(data.msg);
              // $localStore.remove('token')
              // router.replace({
              //   path: '/login'
              // })
              break;
            case 401:
              Vue.prototype.$Message.error(data.msg);

              $localStore.remove('token')
              router.replace({
                path: '/login'
              })
              break;
            case 402: // 无操作权限
              // getVuePro.call(Vue.prototype).$Message.error(data.msg);
              Vue.prototype.$Message.error(data.msg);
              break;
            case(403):
              break;
            case(405):
              const $globalStore = selfGlobal && selfGlobal.$globalStore;
              const getFlag = $globalStore.getters.showPasswordFlag;
              if ($globalRequestMeth) {
                $globalRequestMeth.request = false;
              }
              if (!getFlag) $globalStore.commit('setShowPasswordFlag', true);
              break;
            case(408):
              break;
            case 406:
              $localStore.remove('token');
              router.replace({
                path: '/login'
              })
              break;
            case 413:
              $localStore.remove('token');
              location.reload(true)
              break;
            case 1000:
              Vue.prototype.$Message.error(data.msg);

              $localStore.remove('token')
              router.replace({
                path: '/login'
              })
              break;
            default:
              if ($globalRequestMeth && !$globalRequestMeth.request) {
                $globalRequestMeth.request = true;
                $globalRequestMeth.methodList.forEach(item => {
                  item.method && item.method();
                })
              }
              $globalRequestMeth.methodList = [];
              if (data.status !== 200){
                Vue.prototype.$Message.error(data.msg);
              }
              resolve(data);
              // setTop()
          };
        },
        error: function (error) {
          // const $Message = getVuePro.call(Vue.prototype).$Message;
          const $Message = Vue.prototype.$Message;
          const $globalI18n = Vue.prototype.$selfGlobal.$globalI18n;
          switch (error.status) {
            case(500):
              $Message.error($globalI18n.tc('js.request.systemError'));
              // alert("服务器系统内部错误");
              break;
            case(401):
              $Message.error($globalI18n.tc('js.request.unLogin'));
              $localStore.remove('token')
              router.replace({
                path: '/login'
              })
              // alert("未登录");
              break;
            case(403):
              $Message.error($globalI18n.tc('js.request.unLogin'));
              // alert("无权限执行此操作");
              break;
            case(408):
              $Message.error($globalI18n.tc('js.request.timeOut'));
              // alert("请求超时");
              break;
            case(0):
              $Message.error($globalI18n.tc('js.request.linkError'));
              break;
            default:
              $Message.error($globalI18n.tc('js.request.unknownMis'));
              // alert("未知错误");
              break;
          }
          reject({
            code: error.status,
          });
        },
        complete() {
          if (param && !param.noLoading && getLoading.loadingConfig.countLoading > 0) {
            getLoading.loadingConfig.countLoading -= 1;
          }
          getLoading.hide();
        },
      });
    }
  )
};


export const ajaxHilo = function (method, url, param, config = {}) {
  // console.log(config)
  return new Promise(function (resolve, reject) {
      // const selfGlobal = getVuePro.call(Vue.prototype).$selfGlobal;
      const selfGlobal = Vue.prototype.$selfGlobal;
      const $localStore = Vue.prototype.$localStore;
      if (config && config.method) {
        selfGlobal && selfGlobal.$globalRequestMeth.methodList.push(config.method);
      }
      if (param && !param.noLoading) {
        getLoading.show();
      }
      $.ajax({
        method: method,
        url: url,
        data: {param_data:JSON.stringify(param)},
        headers: config && config.headers,
        dataType: 'json',
        crossDomain: true,
        timeout: 60 * 1000, // 响应超时时间1min
        xhrFields: {
          withCredentials: true,
        },
        ...(config.configParams || {}),
        success: function (data) {


          // 测试结束
          const $globalRequestMeth = selfGlobal && selfGlobal.$globalRequestMeth;
          switch (Number(data.data.login_status) || data.status) {
            case 400:
              if (config && config.method && config.method.customeHandleData){
                // 如果要自定义处理返回的错误信息
                console.log('rrrrrrrr')
                resolve(data)
                break;
              }
              // getVuePro.call(Vue.prototype).$Message.error(data.msg);
              reject({
                code: 400,
              })
              // alert(data.msg);
              // $localStore.remove('token')
              // router.replace({
              //   path: '/login'
              // })
              Vue.prototype.$Message.error(data.msg.message);

              break;
            case 401:
              Vue.prototype.$Message.error(data.msg.message);

              $localStore.remove('token')
              router.replace({
                path: '/login'
              })
              break;
            case 402: // 无操作权限
              // getVuePro.call(Vue.prototype).$Message.error(data.msg);
              Vue.prototype.$Message.error(data.msg.message);
              break;
            case(403):
              break;
            case(405):
              const $globalStore = selfGlobal && selfGlobal.$globalStore;
              const getFlag = $globalStore.getters.showPasswordFlag;
              if ($globalRequestMeth) {
                $globalRequestMeth.request = false;
              }
              if (!getFlag) $globalStore.commit('setShowPasswordFlag', true);
              break;
            case(408):
              break;
            case 406:
              $localStore.remove('token');
              router.replace({
                path: '/login'
              })
              break;
            case 413:
              $localStore.remove('token');
              location.reload(true)
              break;
            default:
              if ($globalRequestMeth && !$globalRequestMeth.request) {
                $globalRequestMeth.request = true;
                $globalRequestMeth.methodList.forEach(item => {
                  item.method && item.method();
                })
              }
              $globalRequestMeth.methodList = [];
              resolve(data.data);
              // setTop()
          };
        },
        error: function (error) {
          // const $Message = getVuePro.call(Vue.prototype).$Message;
          const $Message = Vue.prototype.$Message;
          const $globalI18n = Vue.prototype.$selfGlobal.$globalI18n;
          switch (error.status) {
            case(500):
              $Message.error($globalI18n.tc('js.request.systemError'));
              // alert("服务器系统内部错误");
              break;
            case(401):
              $Message.error($globalI18n.tc('js.request.unLogin'));
              $localStore.remove('token')
              router.replace({
                path: '/login'
              })
              // alert("未登录");
              break;
            case(403):
              $Message.error($globalI18n.tc('js.request.unLogin'));
              // alert("无权限执行此操作");
              break;
            case(408):
              $Message.error($globalI18n.tc('js.request.timeOut'));
              // alert("请求超时");
              break;
            case(0):
              $Message.error($globalI18n.tc('js.request.linkError'));
              break;
            default:
              $Message.error($globalI18n.tc('js.request.unknownMis'));
              // alert("未知错误");
              break;
          }
          reject({
            code: error.status,
          });
        },
        complete() {
          if (param && !param.noLoading && getLoading.loadingConfig.countLoading > 0) {
            getLoading.loadingConfig.countLoading -= 1;
          }
          getLoading.hide();
        },
      });
    }
  )
};

export const uploadImg = function (url, param) {
  if (!until.upImgSize({target:{files:[param.get('image')]}},30)){
    const $Message = Vue.prototype.$Message;
    $Message.error('文件大小不能超过30M')
    return new Promise(function (resolve, reject) {
      reject({
        code: 400,
      })
    })
  }
  return new Promise(function (resolve, reject) {
      if (param && !param.noLoading) {
        getLoading.show();
      }
      $.ajax({
        method: 'post',
        url: url,
        data: param,
        processData: false,
        contentType: false,
        async: true,
        dataType: "json",
        success: function (data) {
          resolve(data);
        },
        error: function (error) {
          reject(error)
        },
        complete: function() {
          if (param && !param.noLoading && getLoading.loadingConfig.countLoading > 0) {
            getLoading.loadingConfig.countLoading -= 1;
          }
          getLoading.hide();
        },
      });
    }
  )
};
export const uploadFile = function (url, param) {

  return new Promise(function (resolve, reject) {
      if (param && !param.noLoading) {
        getLoading.show();
      }
      $.ajax({
        method: 'post',
        url: url,
        data: param,
        processData: false,
        contentType: false,
        async: true,
        dataType: "json",
        success: function (data) {
          resolve(data);
        },
        error: function (error) {
          reject(error)
        },
        complete: function() {
          if (param && !param.noLoading && getLoading.loadingConfig.countLoading > 0) {
            getLoading.loadingConfig.countLoading -= 1;
          }
          getLoading.hide();
        },
      });
    }
  )
};
function getRequestLang(type) {
  if (type === 'zh-cn') return 'zh-cn';
  else if (type === 'en') return 'en-us';
  else return 'zh-cn';
}

// export const  baseUrl = process.env.NODE_ENV === 'development' ? '' : until.environment()?'https://api.management.chathot.me':'http://test.admin.chathot.me'; // 测试服
export const  baseUrl = process.env.NODE_ENV === 'development' ? '' : until.environment()?'https://api-manage.gamatops.com':'http://test-manage.gamatops.com'; // 测试服

export const  getRequestUrl=function(url) {
  const $store = Vue.prototype.$selfGlobal.$globalStore;
  const $localStore = Vue.prototype.$localStore;
  const getToken = $store.state.token || $localStore.get('token') || '';
  const getUid = $localStore.get('login_uid') || '';

  return baseUrl + url + `?lang=${getRequestLang(Vue.prototype.$selfGlobal.$globalStore.state.locale)}&login_uid=${getUid}&token=${getToken}`;
}
export const  getHoilUrl=function(url,type) {
  const  hiloUrl= '/activity/generalActivities'
  const $store = Vue.prototype.$selfGlobal.$globalStore;
  const $localStore = Vue.prototype.$localStore;
  const getToken = $store.state.token || $localStore.get('token') || '';
  const getUid = $localStore.get('login_uid') || '';

  return baseUrl + hiloUrl + `?lang=${getRequestLang(Vue.prototype.$selfGlobal.$globalStore.state.locale)}&login_uid=${getUid}&token=${getToken}&url_data=${url}&request_type=${type}`;
}
export const ajaxCommunity = function (method,url, param, config={}){
  // console.log(config)
  config.headers = {
    pkgname:'com.gamatop.com'
  }
  return new Promise(function (resolve, reject) {
    // const selfGlobal = getVuePro.call(Vue.prototype).$selfGlobal;
    const selfGlobal = Vue.prototype.$selfGlobal;
    const $localStore = Vue.prototype.$localStore;
    if (config && config.method) {
      selfGlobal && selfGlobal.$globalRequestMeth.methodList.push(config.method);
    }
    if (param && !param.noLoading) {
      getLoading.show();
    }
    $.ajax({
      method: method,
      url: url,
      data: {param_data: JSON.stringify(param)},
      headers: config && config.headers,
      dataType: 'json',
      crossDomain: true,
      timeout: 60 * 1000, // 响应超时时间1min
      xhrFields: {
        withCredentials: true,
      },
      ...(config.configParams || {}),
      // beforeSend: function (XMLHttpRequest) {
      //   XMLHttpRequest.setRequestHeader("test-token", 'abcd');
      //   XMLHttpRequest.setRequestHeader("test-sessid", 'abcd');
      // },
      success: function (data) {
        // console.log(data)


        // 测试结束
        const $globalRequestMeth = selfGlobal && selfGlobal.$globalRequestMeth;
        switch (Number(data.data.login_status) || data.status) {
          case 400:
            if (config && config.method && config.method.customeHandleData) {
              // 如果要自定义处理返回的错误信息
              console.log('rrrrrrrr')
              resolve(data)
              break;
            }
            // getVuePro.call(Vue.prototype).$Message.error(data.msg);
            reject({
              code: 400,
            })
            // alert(data.msg);
            // $localStore.remove('token')
            // router.replace({
            //   path: '/login'
            // })
            // Vue.prototype.$Message.error(data.msg.message);

            break;
          case 401:
            Vue.prototype.$Message.error(data.msg.message);

            $localStore.remove('token')
            router.replace({
              path: '/login'
            })
            break;
          case 402: // 无操作权限
            // getVuePro.call(Vue.prototype).$Message.error(data.msg);
            Vue.prototype.$Message.error(data.msg.message);
            break;
          case(403):
            break;
          case(405):
            const $globalStore = selfGlobal && selfGlobal.$globalStore;
            const getFlag = $globalStore.getters.showPasswordFlag;
            if ($globalRequestMeth) {
              $globalRequestMeth.request = false;
            }
            if (!getFlag) $globalStore.commit('setShowPasswordFlag', true);
            break;
          case(408):
            break;
          case 406:
            $localStore.remove('token');
            router.replace({
              path: '/login'
            })
            break;
          case 413:
            $localStore.remove('token');
            location.reload(true)
            break;
          default:
            if ($globalRequestMeth && !$globalRequestMeth.request) {
              $globalRequestMeth.request = true;
              $globalRequestMeth.methodList.forEach(item => {
                item.method && item.method();
              })
            }
            $globalRequestMeth.methodList = [];
            // console.log('reqData:',data.data)
            resolve(data.data);
          // setTop()
        }
        ;
      },
      error: function (error) {
        // const $Message = getVuePro.call(Vue.prototype).$Message;
        const $Message = Vue.prototype.$Message;
        const $globalI18n = Vue.prototype.$selfGlobal.$globalI18n;
        switch (error.status) {
          case(500):
            $Message.error($globalI18n.tc('js.request.systemError'));
            // alert("服务器系统内部错误");
            break;
          case(401):
            $Message.error($globalI18n.tc('js.request.unLogin'));
            $localStore.remove('token')
            router.replace({
              path: '/login'
            })
            // alert("未登录");
            break;
          case(403):
            $Message.error($globalI18n.tc('js.request.unLogin'));
            // alert("无权限执行此操作");
            break;
          case(408):
            $Message.error($globalI18n.tc('js.request.timeOut'));
            // alert("请求超时");
            break;
          case(0):
            $Message.error($globalI18n.tc('js.request.linkError'));
            break;
          default:
            $Message.error($globalI18n.tc('js.request.unknownMis'));
            // alert("未知错误");
            break;
        }
        reject({
          code: error.status,
        });
      },
      complete() {
        if (param && !param.noLoading && getLoading.loadingConfig.countLoading > 0) {
          getLoading.loadingConfig.countLoading -= 1;
        }
        getLoading.hide();
      },
    });
  })
}
export const getCommunityUrl = function (url,type,generalUrl){
  const $store = Vue.prototype.$selfGlobal.$globalStore;
  const $localStore = Vue.prototype.$localStore;
  const getToken = $store.state.token || $localStore.get('token') || '';
  const getUid = $localStore.get('login_uid') || '';
  return baseUrl + generalUrl + `?lang=${getRequestLang(Vue.prototype.$selfGlobal.$globalStore.state.locale)}&login_uid=${getUid}&token=${getToken}&url_data=${url}&request_type=${type}`;

}

// 格式化数据集合
export const formatData = {
  // 格式化列表 list
  formatListData(data) {
    // 有的有嵌套list字段有的没有

    const listData = data.data.list || data.data || {};
    const listArr = [];
    for (let key in listData) {
      const parKey = parseInt(key);
      if (typeof parKey === 'number' && !isNaN(parKey)) listArr.push(listData[key]);
    }
    return {
      ...data.data,
      list: listArr,
      total: (data.data.list && data.data.list.total) || data.data.total || data.data.count || 0,
      status: data.status,
      msg: data.msg,
    };
  },
}



// WEBPACK FOOTER //
// ./src/js/request.js